import { pickScrV2Value } from "./SCRV2RequestHelpers";

/**
 * G-PR2: SCR identity field pick/format — DTO pass-through only.
 * Do not calculate FinalizedDate or DurationDays in the client.
 */

export const pickScrV2IdentityFields = (raw = {}) => {
  const pickNullable = (camelKey, pascalKey) => {
    if (raw[camelKey] !== undefined) {
      return raw[camelKey];
    }
    if (raw[pascalKey] !== undefined) {
      return raw[pascalKey];
    }
    return null;
  };

  const durationRaw = pickNullable("durationDays", "DurationDays");

  return {
    businessDate: pickScrV2Value(raw, "businessDate", "BusinessDate"),
    finalizedDate: pickNullable("finalizedDate", "FinalizedDate"),
    finalizedAt: pickNullable("finalizedAt", "FinalizedAt"),
    durationDays:
      durationRaw == null || durationRaw === "" ? null : Number(durationRaw),
    isFinalized: Boolean(pickScrV2Value(raw, "isFinalized", "IsFinalized", false)),
  };
};

/** Displays DTO DurationDays as-is (no client calculation). */
export const formatScrV2DurationDays = (durationDays) => {
  if (durationDays == null || durationDays === "") {
    return "-";
  }

  const n = Number(durationDays);
  return Number.isFinite(n) ? String(n) : "-";
};
